module.exports = __webpack_public_path__ + "static/media/flask-loading.771119c4.gif";